import React from "react";
import { CustomCheckboxContainer, CustomCheckboxInput } from "@reach/checkbox";
import "@reach/checkbox/styles.css";
import { createUseStyles } from "react-jss";
import DisplayText, { TextVariant } from "./DisplayText";
import clsx from "clsx";
var useStyles = createUseStyles(function (theme) { return ({
    label: {
        display: "flex",
        alignItems: "center"
    },
    checkboxContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "white",
        border: "1px solid #60869D",
        width: 24,
        height: 24,
        marginRight: 20,
        transition: "background 150ms",
        boxShadow: "none",
        "&.checked": {
            background: theme.color.primary.main,
        }
    },
    check: {
        width: 14,
        height: 11,
    },
    helperText: {
        marginTop: 5,
        marginLeft: 44,
    }
}); });
var Checkbox = function (props) {
    var _a, _b;
    var classes = useStyles();
    var checked = (_a = props.value) !== null && _a !== void 0 ? _a : false;
    return (React.createElement("div", { className: props.className },
        React.createElement("label", { className: classes.label },
            React.createElement(CustomCheckboxContainer, { className: clsx(classes.checkboxContainer, checked && "checked"), checked: checked, onChange: props.onChange },
                React.createElement(CustomCheckboxInput, { name: props.name }),
                React.createElement("svg", { className: classes.check, viewBox: "0 0 14 11" },
                    React.createElement("path", { fill: "white", d: "M 5.25 11 L 0 5.741 L 1.627 3.995 L 5.219 7.571 L 12.342 0 L 14 1.714 Z" }))),
            React.createElement(DisplayText, { variant: TextVariant.s18reg, component: "span", color: props.labelColor }, props.labelText)),
        props.helperText &&
            React.createElement(DisplayText, { className: classes.helperText, variant: TextVariant.s12reg, color: (_b = props.helperColor) !== null && _b !== void 0 ? _b : "#818181" }, props.helperText)));
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map